
import { Component, Vue } from 'vue-property-decorator'
import SearchNav from "@/components/SearchNav/index.vue";
import { clearSearchHistory, getSearchHistoryList, SearchHistoryDto } from "@/api/shoppingMall"
import { Getter } from "vuex-class";

@Component({
  name: 'SearchHistory',
  components: { SearchNav }
})

export default class SearchHistory extends Vue {
  @Getter companyId!: string
  @Getter providerId!: string
  private historyList: Array<SearchHistoryDto> = []
  value = ''
  searchType = '' // 1：店铺搜索 2：店铺商品搜索
  placeholder = ''

  created () {
    this.$nextTick(() => {
      (this.$refs.search as any).getElementsByTagName('input')[0].focus()
    })
    this.searchType = this.$route.query.searchType as string
    if (this.searchType === '1') {
      this.placeholder = '企业名/客户备注名/客户编码'
    } else if (this.searchType === '2') {
      this.placeholder = '商品编码/名称/条形码/关键字'
    }
    this.getHistoryList()
  }

  /**
   * 获取历史搜索记录
   */
  getHistoryList () {
    let params = {
      searchType: this.searchType, // 1：店铺搜索2：店铺商品搜索
      providerId: this.providerId
    }
    getSearchHistoryList(params).then(res => {
      this.historyList = res.data
    })
  }

  clearFunc () {
    let params = {
      searchType: this.searchType, // 1：店铺搜索2：店铺商品搜索
      providerId: this.providerId
    }
    clearSearchHistory(params).then(() => {
      this.$toast({ message: '已清除' })
      this.getHistoryList()
    }).catch(() => { })
  }

  toSearchShop (keyword: string) {
    if (this.searchType === '1') {
      this.$router.replace({
        path: '/searchShop',
        query: {
          keyword: keyword
        }
      })
    } else if (this.searchType === '2') {
      this.$router.replace({
        path: '/searchGoods',
        query: {
          keyword: keyword
        }
      })
    }

  }
}
